import { Grid,Stack } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from "date-fns/locale";
import { useContext } from "react";
import { NewFormContext } from "../../../context/NewFormContext";
import { ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";

type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};

export default function TipoData({ subitem, itemId, indexSubitem }: props) {
  const { setModelo } = useContext(NewFormContext);

  function handleValue(event: Date | null) {
    const newValue = event ? event : null;

    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem,
                  padrao: newValue ? newValue.getTime() : null,
                }
                : subitem
            ),
          }
          : item
      ),
    }));
  }

  return (
    <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%'>
      <Grid container spacing={1} width='100%'>
        <Grid size={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <DesktopDatePicker
              sx={{ width: '100%' }}
              format='dd/MM/yyyy'
              value={subitem.padrao as Date ?? null}
              onChange={(event) => handleValue(event)}
              slotProps={{
                actionBar: {
                  actions: ['clear'],
                },
                field: {
                  readOnly: true,
                },
              }}
              localeText={{
                clearButtonLabel: 'Limpar',
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
    </Stack >
  );
}
